// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { findAccountingNavChildren } from '@/accounting/components/accounting-nav';
import {
  SectionBreadcrumbItem,
  SectionBreadcrumbs,
} from '@/components/section-breadcrumbs';
import { findReportNavChildren } from '@/report/components/report-nav';

interface Props {
  /**
   * The title of the current report page.
   */
  title: string;

  /**
   * The page that should own this report in breadcrumbs.
   */
  parent?: 'reports' | 'accounting';
}

/**
 * A breadcrumb component for report pages. The root crumb exposes a
 * quick-jump dropdown to sibling reports within the section.
 */
export function ReportBreadcrumbs(props: Props) {
  const parent = props.parent ?? 'reports';
  const rootLabel = parent === 'accounting' ? 'Accounting' : 'Reports';
  const rootTo = parent === 'accounting' ? '/accounting' : '/reports';
  const sections =
    parent === 'accounting'
      ? findAccountingNavChildren(rootLabel)
      : findReportNavChildren(rootLabel);

  const items: SectionBreadcrumbItem[] = [
    {
      label: rootLabel,
      to: rootTo,
      sections,
    },
    { label: props.title },
  ];

  return <SectionBreadcrumbs items={items} />;
}
